import { apiClient } from "../apiClient";

export const TRA_CUU_DIEM_ENDPOINT = 'tra-cuu-diem';
export const traCuuDiemApi = {
    SelectTraCuuDiemByMaSv: (ma_sv: string) => apiClient.get(`${TRA_CUU_DIEM_ENDPOINT}/sinh-vien/${ma_sv}`),
};